webpackJsonp([8],{

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuAccount_vue__ = __webpack_require__(499);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2941fefc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuAccount_vue__ = __webpack_require__(524);
function injectStyle (ssrContext) {
  __webpack_require__(522)
}
var normalizeComponent = __webpack_require__(17)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MenuAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2941fefc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MenuAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_AppState__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["item"],
  data: function data() {
    return {
      AppState: __WEBPACK_IMPORTED_MODULE_1__util_AppState__["a" /* default */],
      user: __WEBPACK_IMPORTED_MODULE_0__firebase__["a" /* FirebaseAuth */].currentUser || {}
    };
  },

  methods: {
    backToMenu: function backToMenu() {
      this.$emit("backToMenu");
    },
    updateUser: function updateUser(ev) {
      var _this = this;

      this.AppState.loading = true;
      this.user.updateProfile({
        displayName: ev.target.value
      }).then(function () {
        _this.AppState.loading = false;
      }).catch(function (error) {
        _this.AppState.loading = false;
        _this.AppState.error.text = error;
        _this.AppState.error.show = true;
      });
    }
  }
});

/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(523);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(444)("afdfd69e", content, true, {});

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(443)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"MenuAccount.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 524:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-menu-wrapper"},[_c('v-list',[_c('v-list-tile',{staticClass:"menu_close",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.backToMenu($event)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("chevron_left")])],1),_vm._v(" "),_c('v-list-tile-title',[_c('v-icon',{domProps:{"innerHTML":_vm._s(_vm.item.icon)}}),_vm._v(" "+_vm._s(_vm.item.title))],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"menu-item"},[_c('v-text-field',{attrs:{"disabled":"","label":"Email:"},domProps:{"textContent":_vm._s(_vm.user.email)}})],1),_vm._v(" "),_c('div',{staticClass:"menu-item"},[_c('v-text-field',{attrs:{"disabled":"","label":"Email:"},domProps:{"textContent":_vm._s(_vm.user.uid)}})],1),_vm._v(" "),_c('div',{staticClass:"menu-item"},[_c('v-text-field',{attrs:{"label":"Display Name:","value":_vm.user.displayName},on:{"blur":function($event){_vm.updateUser($event)}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/8.22efbac77269f4d56085.js